import {
  EmployeeApi,
  PageCircularProgress,
  useAbdooReducer,
  UserSettingsActionKind,
  useUser,
} from '@abdoo/common';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface UserDataWrapperProps {
  children?: React.ReactNode;
}

export function UserDataWrapper({ children }: UserDataWrapperProps): JSX.Element {
  const { userSettingsDispatch, userSettingsState } = useAbdooReducer();
  const search = useLocation().search;
  const params = new URLSearchParams(search);
  const shareId = params.get('share');
  const managerInviteCode = params.get('managerInviteCode');

  const { user } = useUser(
    EmployeeApi,
    shareId ?? undefined,
    managerInviteCode ?? undefined,
  );

  useEffect(() => {
    if (user.isSuccess && user.data) {
      userSettingsDispatch({
        type: UserSettingsActionKind.UpdateUser,
        payload: user.data,
      });
    }
  }, [user.data, user.isSuccess, userSettingsDispatch]);

  useEffect(() => {
    if (userSettingsState.refresh > 0) {
      user.refetch();
    }
  }, [user, userSettingsState.refresh]);

  if (user.error) {
    return <>{user.error}</>;
  }

  return <>{user.isLoading || user.isRefetching ? <PageCircularProgress /> : children}</>;
}
